const firstBloodSound = '/sounds/first-blood.mp3'

const gunSounds = {
  default: '/sounds/guns/default-single-shot.mp3',
  ak47: '/sounds/guns/ak47-single-shot.mp3',
  ak47Burst: '/sounds/guns/ak47-multishot.mp3',
  m16: '/sounds/guns/m16-single-shot.mp3',
  m16Burst: '/sounds/guns/m16-multishot.mp3',
  pistol: '/sounds/guns/pistol-single-shot.mp3',
  shotgun: '/sounds/guns/shotgun-single-shot.mp3',
}

const hitStreakSounds = {
  2: '/sounds/hitStreaks/double-kill.mp3',
  3: '/sounds/hitStreaks/triple-kill.mp3',
  4: '/sounds/hitStreaks/multi-kill.mp3',
  5: '/sounds/hitStreaks/mega-kill.mp3',
  6: '/sounds/hitStreaks/ultra-kill.mp3',
  10: '/sounds/hitStreaks/killing-spree.mp3',
  15: '/sounds/hitCounts/awesome.mp3',
  20: '/sounds/hitCounts/rampage.mp3',
  25: '/sounds/hitCounts/epic.mp3',
  30: '/sounds/hitCounts/massacre.mp3',
  35: '/sounds/hitCounts/thats-amazing.mp3',
  40: '/sounds/hitCounts/unstoppable.mp3',
  45: '/sounds/hitCounts/thats-incredible.mp3',
  50: '/sounds/hitCounts/invincible.mp3',
  // 50: '/sounds/hitCounts/wasted.mp3',
  // 7: '/sounds/hitStreaks/monsterkill.mp3', ??
}

const inGameRewardSounds = {
  random: {
    chaChing: '/sounds/inGameRewards/cha-ching.wav',
  },
}

const rewardSounds = {
  congratulations: '/sounds/postGameRewards/congratulations.mp3',
  flawless: '/sounds/postGameRewards/flawless.mp3',
  negative: '/sounds/postGameRewards/simulator-negative-feedback.mp3',
  perfect: '/sounds/postGameRewards/perfect.mp3',
  positive: '/sounds/postGameRewards/level-up.mp3',
  victory: '/sounds/postGameRewards/victory.mp3',
  wellDone: '/sounds/postGameRewards/well-done.mp3',
}

export {
  firstBloodSound,
  gunSounds,
  hitStreakSounds,
  inGameRewardSounds,
  rewardSounds,
}



// WEBPACK FOOTER //
// ./src/app/const/sounds.js